import axios from "axios";

import { ApiResponse } from "../models/ApiResponse.model";
import {
  DashboardUserLoginRequest,
  DashboardUser,
  SaveDashboardUserRequest,
  DashboardUserChangePasswordRequest,
} from "../models/Auth.model";

class LoginService {
  public async resendOTP(userId: number): Promise<ApiResponse<any>> {
    const response = await axios.post(`/User/ResendOTP?userId=${userId}`);
    return response?.data;
  }

  public async forgotPassword(phone: string): Promise<ApiResponse<any>> {
    const response = await axios.post(
      `/User/ForgetPassword?phone=${encodeURIComponent(phone)}`
    );
    return response?.data;
  }

  public async dashboardUserLogin(
    data: DashboardUserLoginRequest
  ): Promise<ApiResponse<any>> {
    const response = await axios.post(`/DashboardUser/Login`, data);
    return response.data;
  }

  public async getAllDashboardUsers(
    type: string
  ): Promise<ApiResponse<DashboardUser[]>> {
    const response = await axios.get(`/DashboardUser/GetAll/${type}`);
    return response.data;
  }

  public async saveDashboardUser(
    type: string,
    data: SaveDashboardUserRequest
  ): Promise<ApiResponse<any>> {
    const response = await axios.post(`/DashboardUser/Save/${type}`, data);
    return response.data;
  }

  public async deleteDashboardUser(id: number): Promise<ApiResponse<any>> {
    const response = await axios.post(`/DashboardUser/Delete`, null, {
      params: {
        id,
      },
    });
    return response.data;
  }

  public async changeDashboardUserPassword(
    data: DashboardUserChangePasswordRequest
  ): Promise<ApiResponse<any>> {
    const response = await axios.post(`/DashboardUser/ChangePassword`, data);
    return response.data;
  }
}

export default new LoginService();
